import styled from "styled-components";
import { formatTime, MIN_BLOCK } from "../utils";
import { range } from "lodash";
import { useSettings } from "Settings";
import React from "react";

const Container = styled.div`
  padding-top: 60px;
  padding-left: 6px;
  padding-right: 6px;
`;

const TimeLabel = styled.p`
  font-size: 11px;
  position: relative;
  top: -9px;
`;

export type TimeColumnProps = {
  unitHeight: number;
  start: number;
  end: number;
};

export const TimeColumn = React.memo(
  ({ unitHeight, start, end }: TimeColumnProps) => {
    const [settings] = useSettings();

    return (
      <Container>
        {range(start, end + 1, MIN_BLOCK).map((x) => (
          <TimeLabel style={{ height: unitHeight }}>
            {formatTime(x, settings.timeFormat)}
          </TimeLabel>
        ))}
      </Container>
    );
  }
);
